import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "@/App";
import { RouteFallback } from "@/components/layout/RouteFallback";
// Order matters: tokens.css declares the v0.5 CSS variables tailwind reads via
// var(--bg) etc. Import before index.css so the base layer picks them up; DS
// layer last so component classes win over equal-specificity utilities.
import "./styles/tokens.css";
import "./index.css";
import "./styles/ds.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <Suspense fallback={<RouteFallback />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
